(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/constants.js');

const TEXTS = {
  HEADER: 'Mina beställningar',
  NO_ORDERS: 'Du har inga beställningar',
  SHOW_MORE: 'Visa fler',
  TABLE_HEADER: {
    NAME: 'Namn:',
    COUNT: 'Antal:',
    PRICE: 'Pris:',
    VALID_UNTIL: 'Giltig t o m:'
  },
  TABLE_FOOTER: {
    SUM: 'Summa',
    SEK: 'kr'
  },
  ORDER_STATES: {
    REMOVED: 'Ordern är borttagen',
    DOWNLOAD: 'download',
    REVIEW: 'Ordern är under granskning',
    DENIED: 'Ordern är nekad',
    UNKNOWN: 'Orderns status är okänd'
  },
  DOWNLOAD_ORDER: {
    DOWNLOAD_BUTTON_LABEL: 'Hämta digitala lotter',
    SEND_AGAIN_LABEL: 'Skicka igen',
    SEND_AGAIN_SUCCESS_MESSAGE: 'Krypteringsnyckeln har skickats till det registrerade mobilnummret.',
    SEND_AGAIN_SUCCESS_TITLE: 'Krypteringsnyckel skickad',
    SEND_AGAIN_MISSING_PHONE: 'Du saknar telefonnummer för att kunna hämta dekrypteringsnyckeln. Besök "företagsuppgifter" för att lägga till det igen.'
  },
  VALIDATE_VOUCHER: {
    HEADER: 'Kontrollera status på digital lott',
    VOUCHER_CODE: {
      LABEL: 'Kod för digital lott',
      NAME: 'voucher_code',
      MAX: 12,
      MIN: 8,
      MAX_ERROR_MESSAGE: 'En kod kan max innehålla 12 tecken.',
      MIN_ERROR_MESSAGE: 'En kod måste minst innehålla 8 tecken.',
      REQUIRED_ERROR_MESSAGE: 'Du måste ange en kod.'
    },
    BUTTON_LABEL: 'Kontrollera'
  }
};

svs.ticket_partner.myOrders.constants = {
  TEXTS
};


 })(window);